import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";

const BookingCongratsModal = ({
  show,
  setShow,
  slotInfo,
  bookingRequestMsg,
  showRescheduleMsg,
}) => {
  console.log("product--", slotInfo);
  const { t } = useTranslation();

  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
        size="md"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body>
          <div className="de text-center">
            <h2 className="text-center">{t("Congratulations!")}</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="250"
              height="250"
              viewBox="0 0 250 250"
              fill="none"
            >
              <path
                d="M62.5 66.1611L31.25 78.1494V203.133H140.625L161.773 183.837V90.5679L140.625 66.1611H62.5Z"
                fill="#F0F3FC"
              />
              <path
                d="M250 78.1494L218.75 66.1611H140.625V203.133H250V78.1494Z"
                fill="#E1E7F7"
              />
              <path
                d="M31.25 31.2744V78.1494H140.625L161.773 54.7119L140.625 31.2744H31.25Z"
                fill="#FF664F"
              />
              <path
                d="M140.625 31.2744H250V78.1494H140.625V31.2744Z"
                fill="#EB296D"
              />
              <path
                d="M218.75 46.8672H187.5V15.6172H218.75V46.8672Z"
                fill="#FFB700"
              />
              <path
                d="M93.75 46.8672H62.5V15.6172H93.75V46.8672Z"
                fill="#FFD900"
              />
              <path
                d="M117.22 148.934H132.78V163.582H117.22V148.934Z"
                fill="#C1CBEB"
              />
              <path
                d="M195.345 117.684H226.53V132.332H195.345V117.684Z"
                fill="#A1A7C9"
              />
              <path
                d="M148.47 117.684H179.655V132.332H148.47V117.684Z"
                fill="#A1A7C9"
              />
              <path
                d="M101.595 117.684H132.78V132.332H101.595V117.684Z"
                fill="#C1CBEB"
              />
              <path
                d="M195.345 148.934H226.53V163.582H195.345V148.934Z"
                fill="#A1A7C9"
              />
              <path
                d="M148.47 148.934H179.655V163.582H148.47V148.934Z"
                fill="#A1A7C9"
              />
              <path
                d="M61.3633 154.267L46.875 140.633C20.9868 140.633 0 161.62 0 187.508C0 213.396 20.9868 234.383 46.875 234.383L61.3633 220.211V154.267Z"
                fill="#00CDEC"
              />
              <path
                d="M93.75 187.508C93.75 161.62 72.7632 140.633 46.875 140.633V234.383C72.7632 234.383 93.75 213.396 93.75 187.508Z"
                fill="#169AD6"
              />
              <path
                d="M43.0103 187.725L31.6392 176.354L21.2812 186.712L43.0103 208.441L46.875 204.576L54.3643 187.508L46.875 183.86L43.0103 187.725Z"
                fill="#F0F3FC"
              />
              <path
                d="M62.1108 168.625L46.875 183.861V204.577L72.4688 178.983L62.1108 168.625Z"
                fill="#E1E7F7"
              />
            </svg>
            <h5>
              {showRescheduleMsg
                ? "Your session reschedule request has been submitted successfuly."
                : bookingRequestMsg
                ? t("coachingServiceRequestSuccessMsg", {
                    name: slotInfo?.coach_name,
                  })
                : t("sessionSuccessBookingMsg", {
                    name: slotInfo?.coach_name,
                    date: moment(
                      slotInfo?.slot_start_date,
                      "DD-MM-YYYY"
                    ).format("DD MMM, YYYY"),
                    time: slotInfo?.slot_start_time,
                  })}
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-end gap-3 border-0 modal-footer">
          <button
            type="button"
            class="btn btn-primary active-page"
            onClick={handleClose}
          >
            {t("Ok")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingCongratsModal;
